export default __webpack_public_path__ + "static/media/sunny-day.e51b355a.mp4";